<template>
    <router-link :to="to">
        <slot></slot>
        <span v-if="active" class="fa" :class="indicatorClass"></span>
    </router-link>
</template>

<script>
export default {
    props: {
        sortKey: { required: true },
        isDefaultSort: {
            type: Boolean,
            default: false,
        },
        defaultDirection: {
            default: 'asc',
            validator: value => (value === 'asc' || value === 'desc'),
        },
    },
    computed: {
        active() {
            if (!this.$route.query.sortBy && this.isDefaultSort)
                return true;
            return this.$route.query.sortBy === this.sortKey;
        },
        activeDirection() {
            if (this.active)
                return this.$route.query.direction || this.defaultDirection;
        },
        indicatorClass() {
            return {
                'fa-sort-asc':  this.active && this.activeDirection === 'asc',
                'fa-sort-desc': this.active && this.activeDirection === 'desc',
            };
        },
        to() {
            let route = {
                path: this.$route.path,
                params: { ...this.$route.params },
                query: { ...this.$route.query },
            };

            delete route.query.page;

            route.query.sortBy = this.sortKey;

            if (this.active)
                route.query.direction = (this.activeDirection === 'asc') ? 'desc' : 'asc';
            else
                route.query.direction = this.defaultDirection;

            return route;
        },
    },
}
</script>
